import type { Tokens } from '../api/types';

/**
 * Token persistence. localStorage, deliberately: the backend hands the refresh token
 * to the client in the response body (it is not an httpOnly cookie), so there is no
 * XSS-proof option available to us here — sessionStorage would only shorten the session
 * without changing the threat model. The session is meant to last weeks: access token
 * lives 1 day, refresh 30 days.
 */

const KEY = 'mrf.tokens';

export function loadTokens(): Tokens | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Tokens>;
    if (typeof parsed.accessToken !== 'string' || typeof parsed.refreshToken !== 'string') {
      return null;
    }
    return parsed as Tokens;
  } catch {
    // Corrupt or unavailable storage (private mode, quota) — treat as logged out.
    return null;
  }
}

export function saveTokens(tokens: Tokens): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(tokens));
  } catch {
    // Storage full or blocked. The in-memory session still works for this tab.
  }
}

export function clearTokens(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nothing to do */
  }
}
